import { AxiosRequestConfig } from 'axios';
import { getLiveChatApiDomain, isSaasEntryPoint } from '@/utils/saas';
import { getSuffix } from '@/utils/locale';

export function saasDomainInterceptor(config: AxiosRequestConfig) {
  try {
    const { baseURL = '' } = config;
    // 如果是SaaS化租户，并且是chat接口，则走其他域名
    const isSaas = isSaasEntryPoint();
    if (isSaas && /chat\/.*/.test(baseURL)) {
      const suffix = getSuffix(COUNTRY, ENVIRONMENT);
      const formatBaseURL = baseURL.startsWith('/') ? baseURL : `/${baseURL}`;
      config.baseURL = `https://${getLiveChatApiDomain()}${formatBaseURL}`;
    }
    return config;
  } catch (error) {
    return config;
  }
}
